import React, { useState, useEffect } from "react"
import { Link, useNavigate, Navigate } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

import { useSelector, useDispatch } from "react-redux"

//Import Images
import error from "../../assets/images/error-img.png"

const PagesNotFound = props => {
  //meta title
  document.title = "404 Error Page | Equity Sales Finance, INC."

  const [loading, setLoading] = useState(true)
  const [redirect, setRedirect] = useState(false)

  useEffect(() => {
    setLoading(false)
    document.getElementById("preloader").style.display = "none"
    document.getElementById("status").style.display = "none"
  }, [loading])

  const handleRedirect = event => {
    setRedirect(true)
  }

  return (
    <React.Fragment>
      {redirect ? (
        <Navigate
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      ) : (
        <>
          <div className="page-content">
            <Container>
              <Row>
                <Col lg="12">
                  <div className="text-center mb-5">
                    <h1 className="display-2 fw-medium">
                      4
                      <i className="bx bx-buoy bx-spin text-primary display-3" />
                      4
                    </h1>
                    <h4 className="text-uppercase">Sorry, page not found</h4>
                    <div className="mt-5 text-center">
                      <Link
                        className="btn btn-primary waves-effect waves-light "
                        to="#"
                        onClick={e => {
                          handleRedirect()
                          e.preventDefault()
                        }}
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col md="8" xl="6">
                  <div>
                    <img src={error} alt="" className="img-fluid" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </React.Fragment>
  )
}

export default PagesNotFound;
